import { Chip } from '@progress/kendo-react-buttons';
import React, { ComponentState, useEffect, useState, useRef } from 'react'
import {
    Grid,
    GridColumn,
} from "@progress/kendo-react-grid";
import addIcon from "../../../assets/images/add.png";
import { orderBy } from "@progress/kendo-data-query";
import { getter } from "@progress/kendo-react-common";
import { Input, Switch } from "@progress/kendo-react-inputs";
import moment from "moment";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { useNavigate } from "react-router";
import searchIcon from "../../../assets/images/search.png";
import { useDispatch, useSelector } from 'react-redux';
import APP_ROUTES from 'src/helper/app-routes';
import { allClientFilesFiltersAction, deleteClinicDocument, deleteClinicDocumentTag, FetchClientStoredDocument, GetClientStoredDocument, getClinicStoredDocumentByClinicId, getDownloadUrlForFile, saveSwitchStaffValue, saveSwitchValue } from 'src/redux/actions';
import { permissionEnum, userIsSuperAdmin } from "../../../helper/permission-helper";
import DeleteDialogModal from 'src/control-components/custom-delete-dialog-box/delete-dialog';
import AddClinicDocumentTags from './assign-clinic-tag';
import { API_ENDPOINTS } from 'src/services/api-endpoints';
import DatePickerKendoRct from 'src/control-components/date-picker/date-picker';
import MultiSelectDropDown from 'src/control-components/multi-select-drop-down/multi-select-drop-down';
import calender from '../../../assets/images/calendar-03.png';
import { SettingsService } from '../../../services/settingsService';

import trashIcon from "../../../assets/images/trash2.png";
import { customAxios } from 'src/services/useExPressApi';
import { ClientService } from 'src/services/clientService';
import { renderErrors } from "src/helper/error-message-helper";
import DropDownKendoRct from 'src/control-components/drop-down/drop-down';
import AssignClientTags from "src/app-modules/client/client-profile/client-files/add-files-tags"
import { Encrption } from 'src/app-modules/encrption';
import { NotificationManager } from "react-notifications";
import { ClientDropDownComponent } from 'src/app-modules/global-components/client-dropdown';
import { StaffDropDownComponent } from 'src/app-modules/global-components/staff-dropdown/single-select-staff-dropdown';
import { getClientListData, getStaffListData } from 'src/app-modules/global-components/globalDataCheckerService';
import { TableRowsLoader } from 'src/control-components/custom-skelton';
import { puppeteerService } from 'src/services/puppeteerPdfService';

const DATA_ITEM_KEY = "id";
const SELECTED_FIELD = "selected";
const idGetter = getter(DATA_ITEM_KEY);

const ClientFileList = () => {
    const state = useSelector(states => {
        return states;
    });
    const staffLoginInfo = state.getStaffReducer;
    const { switchValue, switchStaffValue, clientList } = state['DocumentReducer'];
    const { FetchClientStoredDocumentState, ClientStoredDocumentState } = state["ClinicsReducer"];
    const dispatch = useDispatch()
    const navigate = useNavigate();

    const { listClinicDocumentByClinicId, allClientFilesFilters } = state['ClientReducer']
    const [page, setPage] = React.useState(0);
    const [pageSize, setPageSize] = React.useState(50);
    const [finalValue, setFinalValue] = useState(1);
    const [selectedState, setSelectedState] = React.useState({});
    const [sort, setSort] = useState([]);
    const [openClientTags, setOpenTags] = React.useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [isAccepted, setIsAccepted] = useState(false)
    const [documents, setDocuments] = useState([]);

    const [isDeleteConfirm, setDeleteConfirm] = useState(false);
    const [openStaffFilter, setOpenStaffFilter] = useState(false);
    const [openClientFilter, setOpenClientFilter] = useState(false);
    const [openFileTypeFilter, setOpenFileTypeFilter] = useState(false);
    // const [selectItem, setSelectItem] = useState<number>()
    const [assignTags, setAssignTags] = useState([]);
    const [docId, setDocId] = useState("");
      const [serviceStartDate, setServiceStartDate] = useState(
        allClientFilesFilters?.serviceStartDate || moment().subtract(30, "days").toDate()
      );
      const [serviceEndDate, setServiceEndDate] = useState(
        allClientFilesFilters?.serviceEndDate || moment().toDate()
      );
    const [tempInitialDate, setTempInitialDate] = useState(serviceStartDate);
    const [tempPrevDate, setTempPrevDate] = useState(serviceEndDate);
    const [errors, setErrors] = useState({});
    const [openDateFilter, setOpenDateFilter] = useState(false);
    const [openTagFilter, setOpenTagFilter] = useState(false);

    const fileTypeData = [
        { fileTypeVal: 1, fileName: "Files" },
        { fileTypeVal: 2, fileName: "Document Attached Files" },
        { fileTypeVal: 3, fileName: "Document Printed Files" },
        { fileTypeVal: 4, fileName: "Treatment Plan Printed Files" }
    ];

    // useEffect(() => {
    //   if(allClientFilesFilters) {
    //     dispatch(FetchClientStoredDocument(true))
    //   }
    // }, [allClientFilesFilters])

      useEffect(() => {
    setIsCheckActiveClient(switchValue !== undefined ? switchValue : isCheckActiveClient)


  }, [switchValue])

  useEffect(() => {
    setIsCheckActiveStaff(switchStaffValue !== undefined ? switchStaffValue : isCheckActiveStaff)

  }, [switchStaffValue])

  useEffect(() => {
    if (clientList != null) {
        setClientsList(clientList);
    }
  }, [clientList])

    const refFileType = useRef(null);
    const refFileTypeClose = useRef(null);
    const refStaff = useRef(null);
    const refStaffClose = useRef(null);
    const refClient = useRef(null);
    const refClientClose = useRef(null);
    

    const [tagsData, setTagsData] = useState([]);
    const [fields, setFields] = useState({
        tagName: allClientFilesFilters?.tagName ? allClientFilesFilters?.tagName : [],
        staff: allClientFilesFilters?.staff ? allClientFilesFilters?.staff : null,
        fileType: allClientFilesFilters?.fileType ? allClientFilesFilters?.fileType : [{ fileTypeVal: 1, fileName: "Files" }],
        client: allClientFilesFilters?.client ? allClientFilesFilters?.client : null
    });
    const [showError, setShowError] = useState(false);
    const [applyButtonClicked, setApplyButtonClicked] = useState(false);
    const [metaData, setMetaData] = useState([]);
    const [staffData, setStaffData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [downloading, setDownLoading] = useState(false);
    const [clientsList, setClientsList] = useState([]);
    const [isCheckActiveClient, setIsCheckActiveClient] = useState(allClientFilesFilters?.isCheckActiveClient ? allClientFilesFilters?.isCheckActiveClient : true);
    const [isCheckActiveStaff, setIsCheckActiveStaff] = useState(allClientFilesFilters?.isCheckActiveStaff ? allClientFilesFilters?.isCheckActiveStaff : true)
    const [shouldStartSearch, setShouldStartSearch] = useState(false);
    const refTag = useRef(null);
    const refTagClose = useRef(null);
    const refPayerClose = useRef(null);

    const userAccessPermission = useSelector(
        (state) => state.userAccessPermission
    );
    const clinicId = useSelector((state) => state.loggedIn.clinicId);

      useEffect(() => {
        document.addEventListener("mousedown", handleClickListener);
        return () => {
          document.removeEventListener("mousedown", handleClickListener);
        };
      }, []);

      const handleSwitchClient = (e) => {
            var changeSwitchValue = e?.target?.value;
            getClientListData(isCheckActiveClient, (changeSwitchValue === true ? false : true))
            dispatch(saveSwitchValue(changeSwitchValue === true ? false : true))
            setIsCheckActiveClient(changeSwitchValue);
      };

      const handleSwitchStaff = (e) => {
            var changeSwitchStaffValue = e?.target?.value;
            getStaffListData(isCheckActiveStaff, (changeSwitchStaffValue === true ? false : true))
            dispatch(saveSwitchStaffValue(changeSwitchStaffValue === true ? false : true))
            setIsCheckActiveStaff(changeSwitchStaffValue);
      };
    
      const handleClickListener = async (event) => {  
        
        if (refTag?.current && !refTag?.current?.contains(event.target)) {
          if (event.defaultPrevented) {
            return;
          }
          setTimeout(() => {
            setOpenTagFilter(false);
          }, 200);
        }

        if (refFileType.current && !refFileType.current?.contains(event.target)) {
          if (event.defaultPrevented) {
            return;
          }
          setTimeout(() => {
            setOpenFileTypeFilter(false);
          }, 200);
        }
    
        if (refStaff.current && !refStaff.current?.contains(event.target)) {
          setTimeout(() => {
            setOpenStaffFilter(false);
          }, 200);
        }

        if (refClient.current && !refClient.current?.contains(event.target)) {
          setTimeout(() => {
            setOpenClientFilter(false);
          }, 200);
        }
      };

    useEffect(() => {
      if(FetchClientStoredDocumentState) {
        setLoading(true);
        const tagList = allClientFilesFilters?.tagName?.length
            ? allClientFilesFilters.tagName.map(tag => tag?.tagName).join(', ')
            : null;
        const fileList = allClientFilesFilters?.fileType?.length
         ? allClientFilesFilters?.fileType.map(file => file?.fileTypeVal).join(', ')
         : null;     
        const startDateFormatted = moment(allClientFilesFilters?.serviceStartDate).startOf('day').format('YYYY-MM-DD');
        const endDateFormatted = moment(allClientFilesFilters?.serviceEndDate).startOf('day').format('YYYY-MM-DD');
        var data = {
            pageNumber: finalValue,
            pageSize: pageSize,
            fileTypes: fileList,
            clientId: fields?.client ? fields?.client?.id : null,
            searchContents: searchQuery ? searchQuery : "",
            tags: tagList,
            startDate: allClientFilesFilters?.serviceStartDate ? startDateFormatted : moment(serviceStartDate).startOf('day').format('YYYY-MM-DD'),
            endDate: allClientFilesFilters?.serviceEndDate ? endDateFormatted : moment(serviceEndDate).startOf('day').format('YYYY-MM-DD'),
            uploadedBy: allClientFilesFilters?.staff ? allClientFilesFilters?.staff?.id : null
        };
        dispatch(GetClientStoredDocument(data))
      }

      }, [FetchClientStoredDocumentState])

      useEffect(() => {
        if(ClientStoredDocumentState) {
            setLoading(false);
            const list = ClientStoredDocumentState?.resultData;
            setMetaData(ClientStoredDocumentState?.metaData);
            setOpenTagFilter(false);
            setOpenDateFilter(false);
            setOpenFileTypeFilter(false);
            setOpenStaffFilter(false);
            setDocuments(list);
            setOpenClientFilter(false);
            setIsAccepted(true);
            dispatch(FetchClientStoredDocument(false))
        }
      }, [ClientStoredDocumentState])

  const dataStateChange = (event) => {
    setPage(event.dataState.skip);
    setPageSize(event.dataState.take);
    setSort(event.dataState.sort);
  };


    useEffect(() => {
        dispatch(allClientFilesFiltersAction({
          ...allClientFilesFilters,
          serviceStartDate,
          serviceEndDate,
          staff: fields?.staff, 
          tagName: fields?.tagName,
          fileType: fields?.fileType,
          client: fields?.client
        },
        dispatch(FetchClientStoredDocument(true))
      ));
    }, [serviceEndDate, fields, serviceStartDate]);

    useEffect(() => {
        getClinicTags();
        getStaffList();
        getClientListData(isCheckActiveClient, switchValue)
    }, []);

        const getStaffList = async () => {
      setLoading(true);
      await ClientService.getStaffDDLByClinicId()
        .then((result) => {
          setLoading(false);
          let list = result.resultData;
          setStaffData(list);
        })
        .catch((error) => {
          setLoading(false);
          renderErrors(error)
  
        });
    };

    const getClinicTags = async () => {
        setLoading(true);
        await SettingsService.getClinicTags(clinicId)
            .then((result) => {
                setLoading(false);
                let list = result.resultData;
                setTagsData(list);
            })
            .catch((error) => {
                setLoading(false);
                console.error(error.message);
            });
    };

    const handleHoldDate = (e) => {
        const name = e.target.name;
        let value = e.target.value;
        setErrors({});
        if (name === 'serviceStartDate') {
            if (tempPrevDate && value <= tempPrevDate) {
                setTempInitialDate(value);
            } else if (!tempPrevDate) {
                setTempInitialDate(value);
            }
        } else {
            if (tempInitialDate && value >= tempInitialDate) {
                setTempPrevDate(value);
            } else if (!tempInitialDate) {
                setTempPrevDate(value);
            }
        }
    };

    useEffect(() => {
            const atleastOneFieldValid =
            Array.isArray(fields?.fileType) && fields?.fileType.length > 0 ||
            (fields?.staff) && fields?.staff?.name.trim().length > 0 || 
            (fields?.client) && fields?.client?.name.trim().length > 0 ||
            Array.isArray(fields?.tagName) && fields?.tagName?.length > 0 ||
            searchQuery.trim() !== "";
            const start = moment(serviceStartDate);
            const end = moment(serviceEndDate);
            const diff = end.diff(start, 'days');
            if ((diff > 30) && !atleastOneFieldValid) {
              setShowError(true);
              dispatch(FetchClientStoredDocument(false))
            } else {
              setShowError(false); 
              dispatch(FetchClientStoredDocument(true))
            }
    }, [serviceStartDate, serviceEndDate, fields, searchQuery, ])

    const handleApplyFilter = () => {
        if (tempInitialDate && tempPrevDate) {
            setPage(0);
            setPageSize(50);
            setFinalValue(1);
            setErrors({});
            setOpenDateFilter(false);
            setServiceStartDate(tempInitialDate);
            setServiceEndDate(tempPrevDate);
            
        } else {
            setErrors({
                ...errors,
                serviceStartDate: 'Please select a valid start and end Date.',
            });
        }
    };

    const handleChange = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        setFields({
            ...fields,
            [name]: value,
        });
        setPage(0);
        setPageSize(50);
        setFinalValue(1);
    };

  const handleFilter = (e) => {
    var search = e.target.value;
    setSearchQuery(search);
  };

    useEffect(() => {
      const timeoutId = setTimeout(() => {
        if (shouldStartSearch && searchQuery === "") {
          dispatch(FetchClientStoredDocument(true));
          setShouldStartSearch(false);
        } else if (searchQuery.length > 2) {
          
          dispatch(FetchClientStoredDocument(true));
          setShouldStartSearch(true);

        }
      }, 700);
      return () => clearTimeout(timeoutId);
    }, [searchQuery]);

  const pageChange = (event) => {
    let skip = event.page.skip;
    let take = event.page.take;
    setPage(skip);
    setPageSize(take);
    let newValue = skip / take;
    let finalValue = newValue + 1;
    setFinalValue(finalValue)
    dispatch(FetchClientStoredDocument(true));
  };
    const onHeaderSelectionChange = React.useCallback((event) => {
        const checkboxElement = event.syntheticEvent.target;
        const checked = checkboxElement.checked;
        const newSelectedState = {};
        event.dataItems.forEach((item) => {
            newSelectedState[idGetter(item)] = checked;
        });
        setSelectedState(newSelectedState);
    }, []);

      const clearAllFilter = () => {
    setFields({
      ...fields,
      staff: null,
      client: null,
      fileType: [],
      tagName: null,
    });
    setPage(0);
    setPageSize(50);
    setFinalValue(1);
    setSearchQuery("");
    setServiceStartDate(moment().subtract(30, "days").toDate());
    setServiceEndDate(moment().toDate());
    setTempPrevDate(moment().toDate());
    setTempInitialDate(moment().subtract(30, "days").toDate());
  };

  
  const handleClearStaff = () => {
    setFields({
      ...fields,
      staff: null,
    });
          setPage(0);
      setPageSize(50);
      setFinalValue(1);
  };

  const handleClearClient = () => {
    setFields({
      ...fields,
      client: null,
    });
          setPage(0);
      setPageSize(50);
      setFinalValue(1);
  }

  const handleClearFileType = () => {
    setFields({
      ...fields,
      fileType: null,
    });
          setPage(0);
      setPageSize(50);
      setFinalValue(1);
  }

    const handleClearTag = () => {
    setFields({
      ...fields,
      tagName: [],
    });
          setPage(0);
      setPageSize(50);
      setFinalValue(1);
  }

  function  handleFileDownloadClick(file, fileType) {
    if(fileType === 1) {
      openAttachmentFiles(file)
    }
    else if(fileType === 2) {
      openAttachmentDocFiles(file)
    }
    else if(fileType === 3) {
      openAttachmentDocPrintFiles(file)
    }
    else if(fileType === 4) {
      openAttachmentTPFiles(file)    
    }
  }

    function renderAttachments(documents, fileType) {
        const li = documents.clientDocumentAttachments.map((file) => {
            return (

                <li className="mb-1 mx-1">
                  <a
                    onClick={(e) => {
                      if (!downloading) {
                        handleFileDownloadClick(file, fileType);
                      } else {
                        e.preventDefault();
                      }
                    }}
                    style={{
                      color: downloading ? 'gray' : 'black',
                    }}
                  >
                    {file.fileName}
                  </a>
                </li>
            );
        });
        return (
            <td className=" t-word-cus  k-table-td custom-files-cell ">
                <ul className="d-flex flex-wrap upload-attachemnt list-unstyled files-space mb-0 mt-2 ">
                    {li}
                </ul>
            </td>
        );
    }

      const openAttachmentDocFiles = (obj) => {
        setDownLoading(true);
        customAxios.post(API_ENDPOINTS.GET_CLIENT_S3_DOC_ATTACHMENT_URL_BY_ID + obj.id)
          .then((result) => {
            setDownLoading(false);
            var url = result?.resultData?.fileUrl;
            window.open(url);
          })
          .catch((error) => {
            setDownLoading(false);
          });
      }

    const openAttachmentDocPrintFiles = async (obj) => {
      setDownLoading(true);
      try {
        const response = await customAxios.get(
          `${API_ENDPOINTS.GET_CLINIC_S3_PRINTED_DOCUMENT_URL_BYID}${obj?.id}`
        );
        const s3Url = response?.resultData?.url;
        const s3Response = await fetch(s3Url);
    
        if (s3Response.ok) {
          const zipBlob = await s3Response.blob();
          const result = await puppeteerService.generateClientDocumentPdf(zipBlob);
    
          if (result !== true) {
            renderErrors(result);
          }
        }
      } catch (error) {
        renderErrors(error.message);
      } finally {
        setDownLoading(false);
      }
    };

      const openAttachmentTPFiles =  (document) => {
        setDownLoading(true);
        dispatch(getDownloadUrlForFile(document?.id))
        setDownLoading(false);
      };

    const openAttachmentFiles = (obj) => {
        setDownLoading(true);
        customAxios.get(API_ENDPOINTS.GET_CLIENT_S3_DOC_URL_BY_ID + obj.id)
            .then((result) => {
                var url = result?.resultData?.url;
                window.open(url, '_blank')?.focus();
            })
            .catch((error) => {
            });
        setDownLoading(false);
    }

    const handleAddTags = (id, tagsArry) => {
        setDocId(id);
        setOpenTags(true);
        setAssignTags(tagsArry);
    };

    const handleRemoveTags = (e, obj) => {
        userAccessPermission[permissionEnum.MANAGE_STAFF_FILES] &&
            dispatch(deleteClinicDocumentTag(obj?.id))
    };

      function handleDocumentView(event) {
        navigate(APP_ROUTES.EDIT_STRORED_DOCUMENT, {
          state: { id: event.id },
        });
      }
    

  const handleDeleteDocument = () => {
    setDeleteConfirm(!isDeleteConfirm);
    // setScroll(false);
  };
  const deleteDocument = (id) => {
    setDeleteConfirm(true);
    setDocId(id);
    // setScroll(true);
  };

    const handleCloseTags = ({ updated }) => {
        setOpenTags(!openClientTags);
    };

    return (
        <>
            <div className="flex-wrap">
                <div className="Service-RateList mb-3">
                    <div>
                        <div className="d-flex justify-content-between  mt-3">
                            <h4 className="address-title text-grey ">
                                <span className="f-24">Client Files</span>
                            </h4>
                        </div>
                    </div>
                    <div className="d-block d-lg-flex justify-content-between align-items-center">
                    <div className="content-search-filter mt-2 p-0">
                        <img src={searchIcon} alt="" style = {{top: '25px'}}className="search-icon " />
                        <Input
                            className="icon-searchinput"
                            placeholder="Search"
                            value={searchQuery}
                            onChange={(e) => handleFilter(e)}
                        />
                    </div>
                      {/* <div className="d-flex col-lg-3 justify-content-end align-items-center">
                      <div className="clear-add-filter mr-4 col-md-4 text-end responive-order-3">
                        <p className="mb-0 d-inline" onClick={clearAllFilter}>
                          Clear Filter
                        </p>
                      </div>
                    </div> */}
                    </div>

                    <div className='row align-items-center searchBoxShadow mx-0 blueTheme blue_theme'>
                      <div className='col-lg-9 col-sm-12'>
                          <div className='content-search-filter  px-0 filter-drop-down'>
                    <div className="major-filter client_drop  m-0 responive-order-2 gap-2 py-md-3 py-2">
                        <div
                            className="service-main dropdown email-filter border-dashed-cus position-relative staffButton m-0"
                            onClick={() => setOpenDateFilter(true)}
                            onBlur={() => {
                                if (!applyButtonClicked) {
                                  setOpenDateFilter(false);
                                }
                            }}
                        >
                            {serviceStartDate && serviceEndDate ? (
                                <button className="btn btn-size-cus pl-0" type="button">
                                    <i
                                        ref={refPayerClose}
                                        onClick={() => {
                                          setServiceStartDate(moment().subtract(30, "days").toDate());
                                          setServiceEndDate(moment().toDate());
                                          setTempPrevDate(moment().toDate());
                                          setTempInitialDate(moment().subtract(30, "days").toDate());
                                        }}
                                        className={"fa fa-times cross-icon mr-2"}
                                    ></i>
                                    Date
                                    <span className="border-spann">
                                        {moment(serviceStartDate).format("M/D/yyyy") +
                                            " - " +
                                            moment(serviceEndDate).format("M/D/yyyy")}
                                    </span>
                                </button>
                            ) : (
                                <button className="btn btn-size-cus pl-0" type="button">
                                    <i className={"fa fa-plus cross-icon"}></i>
                                    Select Date
                                </button>
                            )}

                            {openDateFilter && (
                                <div
                                    className="dropdown-service "
                                    onFocus={() => setOpenDateFilter(true)}
                                >
                                    <div className="row staffButton">
                                        <div className="col-md-6 position-relative billingFilterRow">
                                            <DatePickerKendoRct
                                                validityStyles={false}
                                                value={tempInitialDate && new Date(tempInitialDate)}
                                                onChange={handleHoldDate}
                                                name="serviceStartDate"
                                                label="From"
                                                placeholder="M/D/YYYY"
                                            />
                                           <img src={calender} alt="" className="leftIcon " style={{ top: "30px", left: "19px" }} />
                                        </div>
                                        <div className="col-md-6 position-relative billingFilterRow">
                                            <DatePickerKendoRct
                                                validityStyles={false}
                                                value={tempPrevDate && new Date(tempPrevDate)}
                                                onChange={handleHoldDate}
                                                name="serviceEndDate"
                                                label="To"
                                                placeholder="M/D/YYYY"
                                            />
                                             <img src={calender} alt="" className="leftIcon " style={{ top: "30px", left: "19px" }} />
                                        </div>
                                        {errors?.serviceStartDate && (
                                            <div className="col-md-12 align-items-center justify-content-center">
                                                <div className="col-12">
                                                    <p
                                                        style={{
                                                            color: "#d61923",
                                                            fontSize: "12px",
                                                            fontStyle: "italic",
                                                        }}
                                                    >
                                                        {errors?.serviceStartDate}
                                                    </p>
                                                </div>
                                            </div>
                                        )}
                                    </div>

                                    <div
                                        className="row mt-2"
                                        onFocus={() => setOpenDateFilter(true)}
                                        onMouseDown={() => setApplyButtonClicked(true)}
                                        onMouseUp={() => setApplyButtonClicked(false)}
                                    >
                                        <div className="col-lg-12 col-md-12 col-sm-12">
                                            <div className="right-align-docs">
                                                <button
                                                    onClick={handleApplyFilter}
                                                    type="button"
                                                    className="submitButon px-4"
                                                >
                                                    Apply
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>

                        <div
                            onClick={(event) => {
                                if (!refTagClose.current?.contains(event.target)) {
                                    setOpenTagFilter(true);
                                }
                            }}
                            ref={refTag}
                            className="service-main dropdown email-filter border-dashed-cus position-relative staffButton m-0"
                        >
                            <button className="btn btn-size-cus pl-0" type="button">
                                {fields?.tagName && fields?.tagName?.length > 0 ? (
                                    <i
                                        ref={refTagClose}
                                        onClick={handleClearTag}
                                        className={"fa fa-times cross-icon mr-2"}
                                    ></i>
                                ) : (
                                    <i className={"fa fa-plus cross-icon"}></i>
                                )}
                                Tags
                                {fields?.tagName && (
                                    <span
                                        className={
                                            fields?.tagName && fields?.tagName?.length > 0
                                                ? "border-spann"
                                                : ""
                                        }
                                    >
                                        {fields?.tagName?.length === 1
                                            ? fields?.tagName[0].tagName
                                            : fields?.tagName?.length > 0
                                            ? `${fields?.tagName[0].tagName} (+${
                                                fields?.tagName?.length - 1
                                            })`
                                            : ""}
                                    </span>
                                )}
                            </button>

                            {openTagFilter && (
                                <div className="dropdown-service dropDates">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <MultiSelectDropDown
                                                label="Tag Name"
                                                onChange={handleChange}
                                                data={tagsData}
                                                value={fields?.tagName}
                                                textField="tagName"
                                                name="tagName"
                                                dataItemKey="id"
                                                autoClose={false}
                                                required={true}
                                                error={fields?.tagName?.length == 0 && errors.tagName}
                                                placeholder={"Tag Name"}
                                            />
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>

<div
    onClick={(event) => {
        if (!refFileTypeClose.current?.contains(event.target)) {
            setOpenFileTypeFilter(true);
        }
    }}
    ref={refFileType}
    className="service-main dropdown email-filter border-dashed-cus position-relative staffButton m-0"
>
    <button className="btn btn-size-cus pl-0" type="button">
        {fields?.fileType && fields?.fileType.length > 0 ? (
            <i
                ref={refFileTypeClose}
                onClick={handleClearFileType}
                className="fa fa-times cross-icon mr-2"
            ></i>
        ) : (
            <i className="fa fa-plus cross-icon"></i>
        )}
        File Types
        {fields?.fileType && (
            <span className={fields?.fileType.length > 0 ? "border-spann" : ""}>
                {fields?.fileType.length === 1
                    ? fields?.fileType[0].fileName
                    : fields?.fileType.length > 0
                    ? `${fields?.fileType[0].fileName} (+${fields?.fileType.length - 1})`
                    : ""}
            </span>
        )}
    </button>

    {openFileTypeFilter && (
        <div className="dropdown-service dropDates">
            <div className="row">
                <div className="col-md-12">
                    <MultiSelectDropDown
                        label="File Type"
                        onChange={handleChange}
                        data={fileTypeData}
                        value={fields?.fileType}
                        textField="fileName"
                        name="fileType"
                        dataItemKey="fileName"
                        autoClose={false}
                        required={true}
                        error={Array.isArray(fields?.fileType) && fields?.fileType?.length === 0 && errors?.fileType}
                        placeholder="File Type"
                    />
                </div>
            </div>
        </div>
    )}
</div>


                   <div
            onClick={(event) => {
              if (!refStaffClose.current?.contains(event.target)) {
                setOpenStaffFilter(true);
              }
            }}
            ref={refStaff}
                className="service-main dropdown email-filter border-dashed-cus position-relative staffButton m-0"
              >
                <button className="btn  btn-size-cus pl-0 " type="button">
              {fields?.staff && fields?.staff?.name ? (
                    <i
                  ref={refStaffClose}
                  onClick={handleClearStaff}
                      className={"fa fa-times cross-icon mr-2 "}
                    ></i>
                  ) : (
                    <i className={"fa fa-plus cross-icon "}></i>
                  )}
              Uploaded By{" "}
              {fields?.staff && (
                    <span
                      className={
                    fields?.staff && fields?.staff?.name
                          ? "border-spann"
                          : ""
                      }
                    >
                  {fields?.staff?.name
                    ? fields?.staff?.name
                    : ""}
                    </span>
                  )}
                </button>
    
            {openStaffFilter && (
                  <div className="dropdown-service dropDates ">
                    <div className="row">
                  {/* <div className="d-flex justify-content-start">
                    <label>Uploaded By</label>
                  </div> */}
                      <div className="col-md-12">
                                                                  <div className="d-flex justify-content-end align-items-center blue_theme flex-nowrap" >
                                                <Switch
                                                  onChange={handleSwitchStaff}
                                                  checked={isCheckActiveStaff === true ? false : true}
                                                  onLabel={""}
                                                  offLabel={""}
                                                  className="switch-on ml-1"
                                                />
                                                <span className="switch-title-text  text-deign ml-1">
                                                  {" "}
                                                  {isCheckActiveClient
                                                    ? "Show Inactive "
                                                    : "Show Inactive "}
                                                </span>
                                              </div>
                        <StaffDropDownComponent
                          selectedStaff={fields?.staff}
                          onChangeStaff={(event) => {
                            const value = event.target.value;
                            setFields({
                              ...fields,
                              staff: value,
                            });
                            setPage(0);
                            setPageSize(50);
                            setFinalValue(1);
                          }}
                          isCheckActiveStaff={isCheckActiveStaff}
                          switchStaffValue={switchStaffValue}
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>

                   <div
            onClick={(event) => {
              if (!refClientClose.current?.contains(event.target)) {
                setOpenClientFilter(true);
              }
            }}
            ref={refClient}
                className="service-main dropdown email-filter border-dashed-cus position-relative staffButton m-0"
              >
                <button className="btn  btn-size-cus pl-0 " type="button">
              {fields?.client && fields?.client?.name ? (
                    <i
                  ref={refClientClose}
                  onClick={handleClearClient}
                      className={"fa fa-times cross-icon mr-2 "}
                    ></i>
                  ) : (
                    <i className={"fa fa-plus cross-icon "}></i>
                  )}
              Client{" "}
              {fields?.client && (
                    <span
                      className={
                    fields?.client && fields?.client?.name
                          ? "border-spann"
                          : ""
                      }
                    >
                  {fields?.client?.name
                    ? fields?.client?.name
                    : ""}
                    </span>
                  )}
                </button>
    
            {openClientFilter && (
                  <div className="dropdown-service dropDates ">
                    <div className="row">
                  {/* <div className="d-flex justify-content-start">
                    <label>Client</label>
                  </div> */}
                      <div className="col-md-12 staffButton">
                        <div className="d-flex justify-content-end align-items-center  blue_theme flex-nowrap" >
                          <Switch
                            onChange={handleSwitchClient}
                            checked={isCheckActiveClient === true ? false : true}
                            onLabel={""}
                            offLabel={""}
                            className="switch-on ml-1"
                          />
                          <span className="switch-title-text  text-deign ml-1">
                            {" "}
                            {isCheckActiveClient
                              ? "Show Inactive "
                              : "Show Inactive "}
                          </span>
                        </div>
                        <DropDownKendoRct 
                          label="Client"
                          onChange={handleChange}
                          data={clientsList}
                          value={fields?.client}
                          textField="name"
                          dataItemKey={"id"}
                          name="client"
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>


                    </div>
                          </div>
                      </div>
                      <div className='col-lg-3 col-sm-12 d-flex justify-content-end clear-add-filter'>
                        <div className='mr-3'>
                          <p className="mb-0 d-inline" onClick={clearAllFilter}>
                            Clear Filter
                          </p>
                      </div>
                       </div>
                    </div>
                  <div>
                      {showError && <p className='text-danger'>While selecting a date range greater than 30 days, you must select atleast one other filter in order to see accurate results!</p>}</div>
                {loading ? <TableRowsLoader rowsNum={10}/> : <div className="grid-table blueThemeTable filter-grid">
                        <div className=" mt-3">
              <Grid
                data={documents}
                dataItemKey={DATA_ITEM_KEY}
                selectedField={SELECTED_FIELD}
                skip={page}
                take={pageSize}
                total={metaData?.totalCount}
                onPageChange={pageChange}
                // onRowClick={(e) => {
                //   navigate(AppRoutes.EDIT_STRORED_DOCUMENT, {
                //     state: { id: e.dataItem.id },
                //   });
                // }}
                className="pagination-row-cus"
                pageable={{
                  pageSizes: [50, 100, 250, 500, 750, 1000],
                }}
                onDataStateChange={dataStateChange}
                sort={sort}
                sortable={true}
                onSortChange={(e) => {
                  setSort(e.sort);
                }}
              >
                <GridColumn
                  width="200px"
                  field="docName"
                  title="File Name/Doc ID"
                  className='cursor-default'
                />

                <GridColumn
                  width="200px"
                  className='cursor-default'
                  field="clientName"
                  title="Client Name"                  
                />
                
                <GridColumn
                  width="200px"
                  title="File Tags"
                  className="cursor-default"
                  cell={(props) => {
                    let field = props?.dataItem.id;
                    let tagsArry = props?.dataItem.clientDocumentTags;
                    if(tagsArry?.length > 0) {
                    return (
                      <td >
                        <div className="cursor-default text-theme d-flex flex-wrap gap-2 align-items-start">
                        {tagsArry.length > 0 &&
                          tagsArry.map((obj) => (
                            <Chip
                              text={obj.tagName}
                              key={obj.id}
                              value="chip"
                              rounded={"large"}
                              fillMode={"solid"}
                              // removable={true}
                              size={"medium"}
                              style={{
                                backgroundColor: obj.color,
                                color: "#ffffff",
                              }}
                              // onRemove={(e) => {
                              //   handleRemoveTags(e, obj);
                              // }}
                            />
                          ))}
                          </div>
                      </td>
                    );
                    }
                    else {
                      return (
                        <td
                          className="cursor-default"
                        >
                          
                        </td>
                      )
                    }
                  }}
                />
                <GridColumn
                  width="150px"
                  field="fileType"
                  title="File Type"
                  className="cursor-default"
                  cell={(props) => {
                    let field = props?.dataItem?.fileType
                    const currentFileType = fileTypeData.find((item) => item?.fileTypeVal === field)
                    return <td className="cursor-default">{currentFileType?.fileName}</td>;
                  }}
                />
                <GridColumn
                  width="150px"
                  // columnMenu={columnMenus}
                  field="createdByStaffName"
                  title="Uploaded By"
                  className="cursor-default"
                />
                <GridColumn
                  width="250px"
                  cell={(props) => {
                    let field = props?.dataItem;
                    return renderAttachments(field, field?.fileType);
                  }}
                  title="Files"
                  className="cursor-default"
                />
                <GridColumn
                  width="200px"
                  title="Date Uploaded"
                  cell={(props) => {
                    let field = moment
                      .utc(props?.dataItem?.utcDateCreated)
                      .local()
                      .format("M/D/YYYY hh:mm A");
                    return <td className="cursor-default">{field}</td>;
                  }}
                />
              </Grid>

              {openClientTags && (
                <AssignClientTags onClose={handleCloseTags} docId={docId} />
              )}
                        </div>
                    </div>}
                </div>
            </div>
        </>
    )
}

export default ClientFileList